module.exports = __webpack_public_path__ + "static/img/storage1.5372e6dc.png";